import React from "react";
import { Link } from "react-router-dom";
import queryParser from "../../../helpers/queryParser";
import formatDate from "../../../helpers/formatDate";
import getBraintreePaymentUrl from "../../../helpers/getBraintreePaymentUrl";

// import styles from "./index.module.scss";
import SortElement from "../../../components/Table/SortElement";
import getPaidCurrency from "../../../helpers/getPaidCurrency";
import formatTabelCell from "../../../helpers/formatTabelCell";
import getChargebeeInvoiceUrl from '../../../helpers/getChargebeeInvoiceUrl';
import dashboardStyles from "../dashboard.module.scss";
import componentStyles from "./components/index.module.scss";
import useModal from '../../../hooks/useModal';
import ShowVideoInModal from '../../../components/Modals/ShowVideoInModal';
import ShowVideoInfoInModal from '../../../components/Modals/ShowVideoInfoInModal';
import classNames from "classnames";

const VideoAction = ({ video }) => {
  const [modalVisible, toggleModal] = useModal();
  const handleToggleModal = () => toggleModal((prevState) => !prevState);

  const [videoWhereUsedModalVisible, toggleVideoWhereUsedModal] = useModal();

  const handleToggleModalVideoWhereUsed = () =>
    toggleVideoWhereUsedModal((prevState) => !prevState);
  return (
    <>
     <ShowVideoInModal
        isOpen={modalVisible}
        onConfirm={handleToggleModal}
        onCancel={handleToggleModal}
        video={video}
      />
      <ShowVideoInfoInModal
        isOpen={videoWhereUsedModalVisible}
        onConfirm={handleToggleModalVideoWhereUsed}
        onCancel={handleToggleModalVideoWhereUsed}
        video={video}
      />
      <div className="d-flex justify-content-end w-220px font-size-20 pr-5 ">
        <div className='cursor-pointer' onClick={handleToggleModal}>
          <i className="bx bx-play-circle text-grey mr-3" />
        </div>
        <div className='cursor-pointer' onClick={handleToggleModalVideoWhereUsed}>
          <i className="bx bx-show text-grey mr-3" />
        </div>
        <Link to={`/video-library/${video.id}`} onClick={(event) => event.stopPropagation()}>
          <i className="bx bx-edit text-grey mr-3" />
        </Link>
        {/* <Link to="#" onClick={() => toggleModal()}>
          <i className="bx bx-trash text-grey" />
        </Link> */}
     </div>
    </>
   
  )
}

export default function videoListStructure(location) {
  const { orderType } = queryParser(location.search);

  return [
    {
      dataField: "id",
      text: "Video Id",
      formatter: (cellContent) => (
        <>{formatTabelCell(cellContent)}</>
      ),
    },
    {
      dataField: "title",
      text: "Video Title",
      formatter: (cellContent) => (
        <>{formatTabelCell(cellContent)}</>
      ),
    },
    {
      text: "Asset Id",
      formatter: (cellContent, rowContent) => (
        <>{rowContent.translateVideoJobs.length > 0 ? rowContent.translateVideoJobs[0].jobId : '-'}</>
      ),
    },
    {
      text: "Video Tags",
      formatter: (cellContent, rowContent) => (
        <p
            className={classNames(dashboardStyles.tableTitle, "d-flex flex-wrap")}
          >
            {rowContent.fileTags.map(tag => {
              return (<span className={classNames(componentStyles.videoLibraryTags, 'mr-1')}>
              {tag.name}
            </span>)
            })}
        </p>
      ),
    },
    {
      text: "Action",
      formatter: (cellContent, rowContent) => <VideoAction video={rowContent} />,
    },
  ];
}
